import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
// import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels"; // Custom Code
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
// import React, { useState } from "react"; // Custom Code
import { css } from "styled-components";

/* Custom Code - Start */
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@store/Framework/Common/GoogleAnalytics";
import useExpandProps from "@store/Framework/Common/Hooks/useExpandProps";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import React, { HTMLAttributes, useState } from "react";
/* Custom Code - End */

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel | ProductModel; // Custom Code
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    // Custom Code
    overridedStyles?: ProductDescriptionStyles;
    // Store Custom Code
    href?: string;
}

type Props = OwnProps & HTMLAttributes<HTMLElement>; // Custom Code;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    // Custom Code
    wrapper?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    wrapper: {
        forwardAs: "div",
    },
    productDetailLink: {
        css: linkAltStyles(),
    },
};

const ProductDescription = ({
    product: baseProduct, // Custom Code
    onClick,
    extendedStyles,
    // Custom Code
    overridedStyles,
    // Store Custom Code
    href,
}: Props) => {
    /* Custom Code - Start */
    const styles = useExpandProps(productDescriptionStyles, extendedStyles, overridedStyles);
    const trackSelectItem = ga.use.trackSelectItem({ items: baseProduct });
    const product = "product" in baseProduct ? baseProduct.product : baseProduct;

    const description =
        ("productTitle" in product && product.productTitle) ||
        ("shortDescription" in product && product.shortDescription) ||
        ("description" in product && product.description) ||
        "";

    /* Store Custom Code - Start */
    const productDetailPath =
        href && href !== ""
            ? href
            : "productInfo" in baseProduct
            ? baseProduct.productInfo.productDetailPath
            : ("productUri" in product && product.productUri) || "";
    /* Store Custom Code - End */

    const isActive =
        "isActiveProduct" in product ? product.isActiveProduct : "isActive" in product ? product.isActive : true;

    const output =
        productDetailPath && isActive ? (
            <Link
                {...styles.productDetailLink}
                href={productDetailPath}
                data-test-selector="productDescriptionLink"
                onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
                    onClick && onClick(event);
                    //console.log("GA4 select_item (description)", { product, itemCategoryData }); // eslint-disable-line no-console
                    trackSelectItem();
                }}
            >
                {description}
            </Link>
        ) : (
            <Typography {...styles.productDetailDescription}>{description}</Typography>
        );

    return <Typography {...styles.wrapper}>{output}</Typography>;
    /* Custom Code - End */
};

export default ProductDescription;
